export const layoutMixin = {
  data() {
    return {
      sidebarItems: [
        {
          id: '/accueil',
          link: '/accueil',
          titleMenu: 'Tableau de bord',
          icon_type: 'normal',
          icon: 'dashboard',
        },
        {
          id: '/mairies',
          link: '/mairies',
          titleMenu: 'Mairies',  
          icon: 'location_city',
        },
        {
          id: '/health_center', 
          link: '/health_center',
          titleMenu: 'Centre de santé', 
          icon: 'medication',
        },
        {
          id: '/profil',
          link: '/profil',
          titleMenu: 'Mon profil',
          icon_type: 'normal',
          icon: 'person',
        },
      ],
    };
  }
};
